import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { Content } from './styles';
import Header from './Header';
import { useAuth } from '~/context/AuthContext';

import NFeEntry from './NFeEntry';
import NFeDevolucao from './NFeDevolucao';
import Nfe from './NFeManifest';
import NFCeHistory from './NFCeHistory';

function FiscalPage() {
  return (
    <>
      <Header />
      <Content>
        <Switch>
          <Route path={'/fiscal/manifest'} component={Nfe} />
          <Route path={'/fiscal/entries'} component={NFeEntry} />
          <Route path={'/fiscal/issued'} component={NFCeHistory} />
          <Route path={'/fiscal/returned'} component={NFeDevolucao} />
        </Switch>
      </Content>
    </>
  );
}

export default FiscalPage;
